export default __webpack_public_path__ + "static/media/checklist.f385162a.png";